import { DuplicateSelectionsMap } from '@amzn/awscat-portfolio-assessment-types';
import { Box, Button, Container, Modal, RadioGroup, SpaceBetween } from '@amzn/awsui-components-react';
import React, { PureComponent } from 'react';

import { constants } from '../../../../common/Localization';
import { DUPLICATE_SELECT_OPTION } from '../common-util/resources';
import { DuplicateRecordsMap } from '../common-util/types';
import { getDupQuickSelectOverwriteCount } from './DuplicateHelpers';

interface Props {
    duplicateRecordsMap: DuplicateRecordsMap;
    duplicateSelectionsMap: DuplicateSelectionsMap;
    onQuickSelectChange: (option: DUPLICATE_SELECT_OPTION) => void;
}

interface State {
    selectedOption: DUPLICATE_SELECT_OPTION;
    visible: boolean;
}

const options = [
    {
        label: constants.DUPLICATE_QUICK_SELECT_OPTIONS.MANUAL,
        value: DUPLICATE_SELECT_OPTION.MANUAL,
    },
    {
        label: constants.DUPLICATE_QUICK_SELECT_OPTIONS.FIRST,
        value: DUPLICATE_SELECT_OPTION.FIRST,
    },
    {
        label: constants.DUPLICATE_QUICK_SELECT_OPTIONS.LAST,
        value: DUPLICATE_SELECT_OPTION.LAST,
    },
];

/**
 * A panel on the top of the duplicate page with options to quickly select duplicate records for all IDs
 */
class QuickSelectPanel extends PureComponent<Props, State> {
    state = {
        selectedOption: DUPLICATE_SELECT_OPTION.MANUAL,
        visible: false,
    };

    prevOption = DUPLICATE_SELECT_OPTION.MANUAL;

    onRadioChange = (e: any): void => {
        this.prevOption = this.state.selectedOption;
        const newOption = e.detail.value;
        this.setState({
            selectedOption: newOption,
        });
        const { duplicateSelectionsMap, duplicateRecordsMap, onQuickSelectChange } = this.props;
        // add friction if the new option will modify any existing duplicateSelection
        if (newOption !== DUPLICATE_SELECT_OPTION.MANUAL &&
            getDupQuickSelectOverwriteCount(duplicateSelectionsMap, duplicateRecordsMap, newOption) > 0) {
            this.setState({
                visible: true,
            });
        } else {
            onQuickSelectChange(newOption);
        }
    };

    onConfirm = (): void => {
        this.props.onQuickSelectChange(this.state.selectedOption);
        this.setState({
            visible: false,
        });
    };

    onCancel = (): void => {
        this.setState({
            selectedOption: this.prevOption,
            visible: false,
        });
    };

    render() {
        const { visible, selectedOption } = this.state;
        const footer = (
            <Box float='right'>
                <SpaceBetween direction='horizontal' size='s'>
                    <Button variant='link' onClick={this.onCancel}>{constants.CANCEL_BUTTON}</Button>
                    <Button variant='primary' onClick={this.onConfirm}>{constants.CONTINUE_BUTTON}</Button>
                </SpaceBetween>
            </Box>
        );
        return (
            <div>
                <Container header={<h2>{constants.DUPLICATE_QUICK_SELECT_TITLE}</h2>}>
                    <RadioGroup
                        onChange={this.onRadioChange}
                        items={options}
                        value={selectedOption}
                        name='duplicateQuickSelection'
                    />
                </Container>
                <Modal
                    visible={visible}
                    header={constants.DUPLICATE_QUICK_SELECT_FRICTION_HEADER}
                    footer={footer}
                    onDismiss={this.onCancel}
                >
                    {constants.DUPLICATE_QUICK_SELECT_FRICTION_CONTENT}
                </Modal>
            </div>
        );
    }
}

export default QuickSelectPanel;
